export default __webpack_public_path__ + "static/media/rectangleBlackLoader.090e959b.svg";